import { Box } from '@terra/ui-styled-system';

type IndicatorDotProps = {
  color?: string;
  position?: 'absolute' | 'inline';
};

export function IndicatorDot({
  color = 'terra.9',
  position = 'absolute',
}: IndicatorDotProps) {
  return (
    <Box
      position={position === 'absolute' ? 'absolute' : undefined}
      top={position === 'absolute' ? '-1px' : undefined}
      right={position === 'absolute' ? '-2px' : undefined}
      flexShrink={position === 'inline' ? 0 : undefined}
      w="1.5"
      h="1.5"
      borderRadius="full"
      bg={color}
    />
  );
}
